import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-taxrelief',
    templateUrl: './taxrelief.component.html',
    styleUrls: ['./taxrelief.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaxreliefComponent implements OnInit {
  status=false;
  constructor() { }

  ngOnInit() {
  }

}
